// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d2c8bd6","453":"62603824","455":"0fa2bbd4"}[chunkId] + ".chunk.js";
};